import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MODULE_INITIALIZER } from '@spartacus/core';
import { timer } from 'rxjs';
import { effects } from './effects';
import { WishlistLazyService, WishlistService } from './services';

function initWishlistFactory(wishlistLazyService: WishlistLazyService): () => void {
  return () => {
    timer(0).subscribe(() => wishlistLazyService.loadEntries());
  };
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    WishlistLazyService,
    {
      provide: WishlistService,
      useExisting: WishlistLazyService,
    },
    {
      provide: MODULE_INITIALIZER,
      useFactory: initWishlistFactory,
      deps: [WishlistLazyService],
      multi: true,
    },
  ],
})
export class WishlistFeatureModule {}
